import {useCallback, useEffect, useMemo,  useState} from "react";
import {endOfYesterday, startOfMonth} from "date-fns";
import ReactDOM from 'react-dom';
import "chartjs-adapter-date-fns";

import {LinearProgress} from "@mui/material";

import useAuthenticatedRequest from "../../../../lib/useAuthenticatedRequest";
import { formatDateForServer } from "../../../../lib/Utility";
import ModalVariables from "../ModalVariables";
import generateDatasets from "../generateDatasets";
import {FREQUENCIES, PERIODS} from "../settings";
import { HACCPFooter } from "../HACCPFooter";
import ChartLine from "./ChartLine";

export default function IndexLine(props) {
  const {site, variablesList, openMap, mapExist} = props

  const [{isLoading: dataLoading, data: chartDataResponse},triggerRequest,] = useAuthenticatedRequest();

  const [variables, setVariables] = useState(
    variablesList.reduce((acc, {color, variable}) => ({
      ...acc,
      [variable.variable_id]: {
        id: variable.variable_id,
        color,
        name: [variable.device_name, variable.variable_name].join(" - "),
        hash: variable.variable_hash,
        avg: undefined,
      }
    }),{})
  );

  const fromStartOfMonth = (startOfMonth(new Date()) > endOfYesterday()) ? startOfMonth(endOfYesterday()) : startOfMonth(new Date());
  const toEndOfYesterday = endOfYesterday();

  const [checkedVariables, setCheckedVariables] = useState(Object.keys(variables).map(Number));
  const [chartVars, setChartVars] = useState([])

  const [selectedPeriod, setSelectedPeriod] = useState(PERIODS.LAST_MONTH);
  const [selectedFrequency, setSelectedFrequency] = useState(FREQUENCIES.ONE_HOUR);
  const [reportFromDate, setReportFromDate] = useState(fromStartOfMonth);
  const [reportToDate, setReportToDate] = useState(toEndOfYesterday);

  const dateRange = chartDataResponse?.dateRange || [];
  const researchedVariables = (chartDataResponse?.vars || []).map(vars => (  vars.idvar));
  const titleVaribles = `Variabili: ${checkedVariables.length} di ${variablesList.length} selezionate`

  const modalPortal = document.getElementById('modal-portal');

  useEffect(() => {
    if(chartDataResponse !== null){
      const vars = (chartDataResponse.vars).filter(item => checkedVariables.includes(item.idvar))
      setChartVars(vars)
    }    
  }, [chartDataResponse,checkedVariables]);

  ///USEEFFECT PER AVERE LA SELEZIONE INIZIALE SOLO SE DISPONIBILE AVGS
  useEffect(() => {
    if (chartDataResponse !== null) {
      // CREO UN SET CON GLI ID DELLE VARIABILI CHE HANNO UN AVG VALIDO
      const validAvgVariableIds = new Set(
        chartDataResponse.vars
          .filter(varItem => varItem.avg != null && varItem.avg !== null)
          .map(varItem => varItem.idvar)
      );
      // ,MANTENGO LA SELEZIONE ORIGINALE DELLE VARIABILI E DESELEZIONO QUELLE CHE NON HANNO UN AVG VALIDO
      const updatedCheckedVariables = checkedVariables.filter(id => validAvgVariableIds.has(id));
      setCheckedVariables(updatedCheckedVariables);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartDataResponse]);

  ////FUNZIONE PER LA RICERCA IN BASE ALLA DATA
  const search = useCallback(() => {
    if (checkedVariables.length > 0) {
      const data = {
        siteID: Number(site.id),
        categoryID: 0, // 0 -> HACCP
        step: selectedFrequency,
        dateStart: formatDateForServer(reportFromDate.toISOString()),
        dateEnd: formatDateForServer(reportToDate.toISOString()),
        ids: checkedVariables.map(String),
      };
      triggerRequest({
        method: "POST",
        url: "chart-line-data",
        data,
      });
    }
  },[checkedVariables, reportFromDate, reportToDate, selectedFrequency, site.id, triggerRequest]);

  useEffect(() => {
    search();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportFromDate, reportToDate, selectedFrequency]);

    ////FUNZIONE PER CAMBIARE, NELLA MODALE DELLE VARIABILI, QUELLE VISUALIZZATE NEL GRAFICO
  const onChangeVariableSelection = useCallback((variableId, checked) => {
    setCheckedVariables(checked ? checkedVariables.concat(variableId) :
      checkedVariables.filter(id => id !== variableId));
  },[checkedVariables]);

    ////DESELEZIONA O SELEZIONA TUTTE LE VARIABILI NELLA MODALE
  const onSelectDeselectAllVariables = useCallback((checked) => {
    setCheckedVariables(checked ? Object.keys(variables).map(Number) : []);
  },[variables]);

  ////FUNZIONE PER CAMBIARE, NELLA MODALE DELLE VARIABILI, IL COLORE NEL GRAFICO
  const onChangeVariableColor = useCallback((variableId, color) => {
    setVariables({
      ...variables,
      [variableId]: {
        ...variables[variableId],
        color,
      },
    });
  },[variables]);


  const datasets = useMemo(() => {
    const vars = generateDatasets(chartVars || [], variables)
    // const vars28Days = generateDatasets(chartVars28DayBefore || [], variables)
    return [
      { name: "currentData", dataset: vars },
      // { name: "data28DaysAgo", dataset: vars28Days },
    ]; 
  },[chartVars,  variables]);
  
  const avgs = (chartVars || []).reduce((acc, {idvar, avg}) => ({
    ...acc,
    [idvar]: avg,
  }), {});
  
  const configModalVariables = {
    configModal: {
      
      search,
      sxStyle:{width: { xs: "100%", sm: "30%" }}
    },
    configVariablesGrid: {
      variables,
      checkedVariables,
      researchedVariables,
      onChangeSelection:onChangeVariableSelection,
      onChangeColor:onChangeVariableColor,
      onSelectDeselectAll:onSelectDeselectAllVariables,
      showAvg:true,
      avgs,
      title:titleVaribles,
    }
  }

  const footerProps = {selectedFrequency, reportToDate, 
          reportFromDate, site, checkedVariables, selectedPeriod,
          setReportFromDate, setReportToDate, setSelectedFrequency, setSelectedPeriod}

  const propsChart = {datasets, dateRange, openMap, mapExist}

  return (
    <>
      <ChartLine {...propsChart} titleTooltip={titleVaribles}/>
      {dataLoading && (<LinearProgress />)}
      {modalPortal && ReactDOM.createPortal(
        <ModalVariables {...configModalVariables}/>,
        modalPortal
      )} 
      <HACCPFooter {...footerProps}/>
    </>
  )
}

